export const STATUSES = [
  {
    id: 'blank',
    value: null,
    label: 'Blank',
    selected: true,
  },
  {
    id: 'to-be-scheduled',
    value: 'to-be-scheduled',
    label: 'To be scheduled',
    selected: true,
  },
  {
    id: 'scheduled',
    value: 'scheduled',
    label: 'Scheduled',
    selected: true,
  },
  {
    id: 'conducted',
    value: 'conducted',
    label: 'Conducted',
    selected: true,
  },
  {
    id: 'late-cancellation-by-patient',
    value: 'late-cancellation-by-patient',
    label: 'Late cancellation by patient',
    selected: false,
  },
  {
    id: 'timely-cancellation-by-patient',
    value: 'timely-cancellation-by-patient',
    label: 'Timely cancellation by patient',
    selected: false,
  },
  {
    id: 'no-show',
    value: 'no-show',
    label: 'No show',
    selected: false,
  },
  {
    id: 'cancelled-by-host',
    value: 'cancelled-by-host',
    label: 'Cancelled by host',
    selected: false,
  },
  {
    id: 'patient-doesnt-want',
    value: 'patient-doesnt-want',
    label: "Patient doesn't want",
    selected: false,
  },
];

export const EVENTS_WITH_CANCELLED_STATUSES = [
  'late-cancellation-by-patient',
  'timely-cancellation-by-patient',
  'cancelled-by-host',
  'no-show',
  'patient-doesnt-want',
];

export const RECORDING_STATUSES = [
  {
    id: 'blank',
    value: null,
    label: 'Blank',
    selected: true,
  },
  {
    id: 'needs-to-be-uploaded',
    value: 'needs-to-be-uploaded',
    label: 'Needs to be uploaded',
    selected: true,
  },
  {
    id: 'uploaded',
    value: 'uploaded',
    label: 'Uploaded',
    selected: true,
  },
  {
    id: 'uploaded-and-checked',
    value: 'uploaded-and-checked',
    label: 'Uploaded and checked',
    selected: true,
  },
  {
    id: 'data-insufficient',
    value: 'data-insufficient',
    label: 'Data insufficient',
    selected: true,
  },
  {
    id: 'not-applicable',
    value: 'not-applicable',
    label: 'Not applicable',
    selected: true,
  },
];

export const NEXT_ACTIONS = [
  {
    id: 'blank',
    value: null,
    label: 'Blank',
    selected: true,
  },
  {
    id: 'schedule-2nd-teleconsultation',
    value: 'schedule-2nd-teleconsultation',
    label: 'Schedule second teleconsultation',
    selected: true,
  },
  {
    id: 'reschedule-the-PG',
    value: 'reschedule-the-PG',
    label: 'Reschedule the PG',
    selected: true,
  },
  {
    id: 'refer-to-sleep-clinic',
    value: 'refer-to-sleep-clinic',
    label: 'Refer to sleep clinic',
    selected: true,
  },
];

export const MANUAL_PAYMENT_STATUSES = [
  {
    id: 'blank',
    value: null,
    label: 'Blank',
    selected: true,
  },
  {
    id: 'paid',
    value: 'paid',
    label: 'Paid',
    selected: true,
  },
  {
    id: 'not-required',
    value: 'not-required',
    label: 'Not required',
    selected: true,
  },
];

export const CURRENT_PAYMENT_STATUSES = [
  {
    id: 'blank',
    value: null,
    label: 'Blank',
    selected: true,
  },
  {
    id: 'succeeded',
    value: 'succeeded',
    label: 'Succeeded',
    selected: true,
  },
  {
    id: 'failed',
    value: 'failed',
    label: 'Failed',
    selected: true,
  },
  {
    id: 'incomplete',
    value: 'incomplete',
    label: 'Incomplete',
    selected: true,
  },
];

export const COLUMNS = [
  {
    label: 'Customer',
    accessor: 'customer',
    type: 'customer',
    isFilterable: false,
    classNames: 'th-list-sticky th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Actions',
    accessor: 'polygraphies',
    type: 'actions',
    isFilterable: false,
    classNames: 'th-list-cellwidth-120',
    selected: true,
  },
  {
    label: 'Address',
    accessor: 'address',
    type: 'customerText',
    isFilterable: false,
    classNames: 'th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Technician',
    accessor: 'technician',
    type: 'technician',
    isFilterable: true,
    classNames: 'th-list-cellwidth-240',
    selected: false,
    options: [
      {
        id: 'blank',
        value: null, //for blank records
        label: 'Blank',
        selected: true,
      },
    ],
  },
  {
    label: 'Dates',
    accessor: 'pickupDate',
    type: 'datetimePicker',
    isFilterable: false,
    isSortable: true,
    sortLabel: 'Delivery date: Later first and Creation date: Earlier first',
    classNames: 'th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'PG notes',
    accessor: 'notes',
    type: 'textWithEditDirect',
    isFilterable: false,
    classNames: 'th-list-cellwidth-240',
  },
  {
    label: 'Status',
    accessor: 'status',
    type: 'select',
    isFilterable: true,
    options: STATUSES,
    classNames: 'th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Recording status',
    accessor: 'recordingStatus',
    type: 'select',
    isFilterable: true,
    options: RECORDING_STATUSES,
    classNames: 'th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Next action',
    accessor: 'nextAction',
    type: 'select',
    isFilterable: true,
    options: NEXT_ACTIONS,
    classNames: 'th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Manual Payment Status',
    accessor: 'manualPaymentStatus',
    type: 'select',
    isFilterable: true,
    options: MANUAL_PAYMENT_STATUSES,
    classNames: 'th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Doctor',
    accessor: 'doctor',
    type: 'doctor',
    isFilterable: true,
    classNames: 'th-list-cellwidth-240',
    selected: true,
    options: [
      {
        id: 'blank',
        value: null, //for blank records
        label: 'Blank',
        selected: true,
      },
    ],
  },
];

export const DOCTOR_COLUMNS = [
  {
    label: 'Customer',
    accessor: 'customer',
    type: 'customer',
    isFilterable: false,
    classNames: 'th-list-sticky th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Dates',
    accessor: 'pickupDate',
    type: 'datetimePicker',
    isFilterable: false,
    isSortable: true,
    sortLabel: 'Delivery date: Later first',
    classNames: 'th-list-cellwidth-240',
    selected: true,
    readOnly: true,
  },
  {
    label: 'Status',
    accessor: 'status',
    type: 'select',
    isFilterable: true,
    options: STATUSES,
    classNames: 'th-list-cellwidth-240',
    readOnly: true,
  },
  {
    label: 'Recording status',
    accessor: 'recordingStatus',
    type: 'select',
    isFilterable: true,
    options: RECORDING_STATUSES,
    classNames: 'th-list-cellwidth-240',
    readOnly: true,
  },
  {
    label: 'Manual Payment Status',
    accessor: 'manualPaymentStatus',
    type: 'select',
    isFilterable: true,
    options: MANUAL_PAYMENT_STATUSES,
    classNames: 'th-list-cellwidth-240',
    readOnly: true,
  },
];

export const TECHNICIAN_COLUMNS = [
  {
    label: 'Customer',
    accessor: 'customer',
    type: 'customer',
    isFilterable: false,
    classNames: 'th-list-sticky th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Health data',
    accessor: 'weight',
    type: 'healthData',
    isFilterable: false,
    classNames: 'th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Address',
    accessor: 'address',
    type: 'customerText',
    isFilterable: false,
    classNames: 'th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Dates',
    accessor: 'pickupDate',
    type: 'datetimePicker',
    isFilterable: false,
    isSortable: true,
    sortLabel: 'Delivery date: Later first',
    classNames: 'th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'PG notes',
    accessor: 'notes',
    type: 'textWithEditDirect',
    isFilterable: false,
    classNames: 'th-list-cellwidth-240',
  },
  {
    label: 'Status',
    accessor: 'status',
    type: 'select',
    isFilterable: true,
    options: STATUSES,
    classNames: 'th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Recording status',
    accessor: 'recordingStatus',
    type: 'select',
    isFilterable: false,
    options: RECORDING_STATUSES,
    classNames: 'th-list-cellwidth-240',
    selected: true,
  },
];

export const CSV_HEADERS = [
  { label: 'Country', key: 'country' },
  { label: 'City', key: 'city' },
  { label: 'Address', key: 'address' },
  { label: 'Name', key: 'name' },
  { label: 'Phone', key: 'phone' },
  { label: 'Technician', key: 'technicianFullName' },
  { label: 'Manual Payment status', key: 'manualPaymentStatus' },
  { label: 'PG Notes', key: 'pgNotes' },
  { label: 'Additional Notes', key: 'additionalNotes' },
  { label: 'createdAt', key: 'createdAt' },
  { label: 'link', key: 'link' },
];
